import { motion } from "framer-motion";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { QuizQuestion as QuizQuestionType, likertOptions } from "./quizData";

interface QuizQuestionProps {
  question: QuizQuestionType;
  selectedValue: number | undefined;
  onSelect: (value: number) => void;
}

const QuizQuestion = ({ question, selectedValue, onSelect }: QuizQuestionProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      className="space-y-4"
    >
      <div className="space-y-2">
        <h3 className="text-xl md:text-2xl font-semibold text-brand-dark leading-relaxed">
          {question.question}
        </h3>
      </div>

      <RadioGroup
        value={selectedValue?.toString()}
        onValueChange={(value) => onSelect(parseInt(value))}
        className="space-y-2"
      >
        {likertOptions.map((option) => (
          <motion.div
            key={option.value}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
          >
            <Label
              htmlFor={`option-${option.value}`}
              className={`flex items-center gap-4 p-3 rounded-xl border-2 cursor-pointer transition-all ${
                selectedValue === option.value
                  ? "border-brand-orange bg-brand-orange/5"
                  : "border-border hover:border-brand-purple/30 hover:bg-muted/50"
              }`}
            >
              <RadioGroupItem
                value={option.value.toString()}
                id={`option-${option.value}`}
                className="border-2 data-[state=checked]:border-brand-orange data-[state=checked]:text-brand-orange"
              />
              <span className="text-base font-medium text-brand-dark">
                {option.label}
              </span>
            </Label>
          </motion.div>
        ))}
      </RadioGroup>
    </motion.div>
  );
};

export default QuizQuestion;
